import React from 'react';
import ExecutiveBranch from '../../executivebranch';

class ExecutiveAppBranch extends React.Component {


  render() {
    return (
      <ExecutiveBranch from='AppControl' menus={this.props.menus} openDrawer={this.props.openDrawer} />
    );
  }
}

export default ExecutiveAppBranch;
